var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "quote-reply col-md-12" }, [
    _vm.formState == "sending"
      ? _c("div", { attrs: { id: "sending" } }, [
          _c("div", { staticClass: "overlay" }),
          _vm._v(" "),
          _c("div", { staticClass: "form-sending" }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "quote-reply__button-row" }, [
        _vm.canAccept
          ? _c(
              "button",
              {
                staticClass: "btn btn--success btn--hollow",
                class: { "btn--active": _vm.formData.action == "accept" },
                on: {
                  click: function ($event) {
                    return _vm.setMode("accept")
                  },
                },
              },
              [_vm._v("\n                Hyväksy tarjous\n            ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.canReject
          ? _c(
              "button",
              {
                staticClass: "btn btn--danger btn--hollow",
                class: { "btn--active": _vm.formData.action == "reject" },
                on: {
                  click: function ($event) {
                    return _vm.setMode("reject")
                  },
                },
              },
              [_vm._v("Hylkää tarjous\n            ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn--call-to-action btn--hollow",
            class: { "btn--active": _vm.formData.action == "info" },
            on: {
              click: function ($event) {
                return _vm.setMode("info")
              },
            },
          },
          [_vm._v("Kysy lisätietoja\n            ")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.formData.action !== null
            ? _c(
                "form",
                {
                  staticClass: "col-md-9 quote-reply__form",
                  attrs: {
                    method: "post",
                    id: "send-quote",
                    name: "send-quote",
                  },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.sendReply.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-8" },
                      [
                        _vm.formData.action == "reject"
                          ? _c("turndown-reason-field", {
                              attrs: {
                                selectedOption:
                                  _vm.formData.selectedTurnDownReason,
                                turnDownOptions: _vm.turnDownRadioOptions,
                              },
                              on: { change: _vm.setTurnDownReason },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "quote-reply__textarea" }, [
                          _c("label", { attrs: { for: "message" } }, [
                            _vm._v(_vm._s(_vm.messageLabel)),
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData.message,
                                expression: "formData.message",
                              },
                            ],
                            attrs: { rows: "12", id: "message" },
                            domProps: { value: _vm.formData.message },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.formData,
                                  "message",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm.formData.action == "accept"
                          ? _c(
                              "div",
                              [
                                _c("tos", {
                                  attrs: {
                                    "has-contract": _vm.hasContract,
                                    id: _vm.id,
                                    checksum: _vm.checksum,
                                  },
                                  model: {
                                    value: _vm.formData.tos,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "tos", $$v)
                                    },
                                    expression: "formData.tos",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn--block btn--send-message",
                            class: _vm.getSubmitButtonClass(
                              _vm.formData.action
                            ),
                            attrs: { type: "submit" },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.buttonText) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }